import { useEffect, useId, useState } from 'react';

const defaultBaseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5008';

export function CompanySelect({ value, onChange, apiBaseUrl = defaultBaseUrl, allValue = '', allLabel = 'Todas as empresas', label = 'Empresa', id, className = 'h-10 w-full border border-gray-700 bg-gray-900 px-3 text-sm text-white outline-none focus:border-green-400' }) {
  const generatedId = useId();
  const selectId = id || generatedId;
  const [state, setState] = useState({ companies: [], loading: true, error: '' });
  useEffect(() => {
    const controller = new AbortController();
    async function load() {
      setState({ companies: [], loading: true, error: '' });
      try {
        const token = localStorage.getItem('@user_token');
        if (!token) throw new Error('Faça login para consultar as empresas.');
        const response = await fetch(apiBaseUrl.replace(/\/$/, '') + '/api/Empresa', { headers: { Authorization: 'Bearer ' + token }, signal: controller.signal });
        const messages = { 401: 'Sua sessão expirou. Faça login novamente.', 403: 'Você não tem permissão para consultar as empresas.', 429: 'Muitas consultas. Aguarde e tente novamente.' };
        if (!response.ok) throw new Error(messages[response.status] || 'Não foi possível carregar as empresas.');
        const companies = await response.json();
        if (!Array.isArray(companies) || companies.some(company => !Number.isInteger(Number(company.codigo)) || Number(company.codigo) <= 0)) throw new Error('Resposta inválida ao consultar as empresas.');
        if (!controller.signal.aborted) setState({ companies, loading: false, error: '' });
      } catch (error) {
        if (!controller.signal.aborted) setState({ companies: [], loading: false, error: error.message });
      }
    }
    load();
    return () => controller.abort();
  }, [apiBaseUrl]);
  return <>
    {label && <label htmlFor={selectId} className="mb-1.5 block text-[9px] font-bold uppercase tracking-[0.15em] text-gray-500">{label}</label>}
    <select id={selectId} value={value} onChange={event => onChange(event.target.value)} disabled={state.loading || Boolean(state.error) || state.companies.length === 0} className={className}>
      <option value={allValue}>{allLabel}</option>
      {state.companies.map(company => <option key={company.codigo} value={String(company.codigo)}>{company.nome_fantasia || `Empresa ${company.codigo} (nome fantasia não informado)`}</option>)}
    </select>
    {state.loading && <p role="status" className="mt-2 text-xs text-gray-400">Carregando empresas...</p>}
    {state.error && <p role="alert" className="mt-2 text-xs text-red-300">{state.error}</p>}
    {!state.loading && !state.error && state.companies.length === 0 && <p className="mt-2 text-xs text-gray-400">Nenhuma empresa cadastrada.</p>}
  </>;
}
